import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Twitter, Send } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-charcoal-deep text-off-white mt-24 border-t border-off-white/10">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="mb-14 border-b border-off-white/10 pb-10">
          <img
            src="https://customer-assets-m6fa6gv7.emergentagent.net/job_neon-workshop-3/artifacts/8muchqej_whip_it_up.png"
            alt="Whip it Up"
            className="w-full max-w-[900px] h-auto object-contain"
          />
          <p className="font-mono text-[10px] md:text-[11px] tracking-[0.3em] text-off-white/50 mt-4">
            // CRAFTED WITH LOVE — NATURALLY · EST. 2023 · MICRO-BATCH
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div>
            <p className="font-mono text-[10px] tracking-[0.3em] text-off-white/50 mb-4">// SHOP</p>
            <ul className="space-y-2">
              <li><Link to="/shop" className="text-sm text-off-white/85 hover:text-rose kinetic-link" style={{ color: undefined }}>All Products</Link></li>
              <li><Link to="/shop/body-butter" className="text-sm text-off-white/85 hover:text-rose kinetic-link">Body Butter</Link></li>
              <li><Link to="/shop/body-oil" className="text-sm text-off-white/85 hover:text-rose kinetic-link">Body Oil</Link></li>
              <li><Link to="/shop/spray-oil" className="text-sm text-off-white/85 hover:text-rose kinetic-link">Spray Oil</Link></li>
              <li><Link to="/shop/glow-trio" className="text-sm text-off-white/85 hover:text-rose kinetic-link">Glow Trio</Link></li>
            </ul>
          </div>
          <div>
            <p className="font-mono text-[10px] tracking-[0.3em] text-off-white/50 mb-4">// INFO</p>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-off-white/85 hover:text-rose kinetic-link">About Me</Link></li>
              <li><a href="#" className="text-sm text-off-white/85 hover:text-rose kinetic-link">Wholesale</a></li>
              <li><a href="#" className="text-sm text-off-white/85 hover:text-rose kinetic-link">Contact</a></li>
              <li><a href="#" className="text-sm text-off-white/85 hover:text-rose kinetic-link">Wholesale Inquiry</a></li>
            </ul>
          </div>
          <div>
            <p className="font-mono text-[10px] tracking-[0.3em] text-off-white/50 mb-4">// HELP</p>
            <ul className="space-y-2">
              <li><a href="#" className="text-sm text-off-white/85 hover:text-rose kinetic-link">Shipping</a></li>
              <li><a href="#" className="text-sm text-off-white/85 hover:text-rose kinetic-link">Return Policy</a></li>
              <li><a href="#" className="text-sm text-off-white/85 hover:text-rose kinetic-link">FAQ</a></li>
              <li><a href="#" className="text-sm text-off-white/85 hover:text-rose kinetic-link">Privacy</a></li>
            </ul>
          </div>
          <div>
            <p className="font-mono text-[10px] tracking-[0.3em] text-off-white/50 mb-4">// NEWSLETTER</p>
            <p className="text-sm text-off-white/80 mb-4">First drops. Zero spam.</p>
            <form onSubmit={(e) => e.preventDefault()} className="flex border border-off-white/25 focus-within:border-rose transition-colors-only">
              <input
                type="email"
                placeholder="you@domain.com"
                className="flex-1 bg-transparent px-3 h-11 text-sm outline-none placeholder-off-white/40 text-off-white"
              />
              <button type="submit" className="h-11 w-11 flex items-center justify-center transition-colors-only hover:opacity-80" style={{ backgroundColor: "#D89999", color: "#1A1A1A" }}>
                <Send size={15} />
              </button>
            </form>
            <div className="flex items-center gap-4 mt-5">
              <a href="#" className="text-off-white/60 hover:text-rose transition-colors-only"><Instagram size={16} /></a>
              <a href="#" className="text-off-white/60 hover:text-rose transition-colors-only"><Twitter size={16} /></a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-off-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="font-mono text-[10px] tracking-[0.2em] text-off-white/50">
            © {new Date().getFullYear()} WHIP IT UP. ALL RIGHTS RESERVED.
          </p>
          <p className="font-mono text-[10px] tracking-[0.2em] text-off-white/50">
            CRAFTED IN THE USA · SHIPPED WORLDWIDE
          </p>
          <p className="font-mono text-[10px] tracking-[0.2em] text-off-white/50">
            POWERED BY{" "}
            <a
              href="https://traceelements.dev"
              target="_blank"
              rel="noopener noreferrer"
              className="text-rose hover:text-off-white transition-colors-only kinetic-link"
            >
              TRACEELEMENTS
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
